// extracted by mini-css-extract-plugin
export default {"wrap":"RefreshReminder_wrap","iconContainer":"RefreshReminder_iconContainer","heading":"RefreshReminder_heading","bodyText":"RefreshReminder_bodyText"};